import axios from "../axios";

export const purchasesApi = {
  // Get all purchases
  getPurchases: async (params = {}) => {
    return axios.get("/inventory/purchases", { params });
  },

  // Get a single purchase by ID
  getPurchase: async (id) => {
    return axios.get(`/inventory/purchases/${id}`);
  },

  // Create a new purchase
  createPurchase: async (data) => {
    const { request_key, ...purchase } = data;
    return axios.post("/inventory/purchases", {
      purchase,
      request_key,
    });
  },

  // Update an existing purchase
  updatePurchase: async (id, data) => {
    return axios.put(`/inventory/purchases/${id}`, {
      purchase: data,
    });
  },

  // Delete a purchase
  deletePurchase: async (id, version) => {
    return axios.delete(`/inventory/purchases/${id}`, { data: { version } });
  },

  // Send purchase to supplier
  sendToSupplier: async (id, data) => {
    return axios.post(`/inventory/purchases/${id}/send_to_supplier`, data);
  },

  // Mark purchase as sent
  markAsSent: async (id) => {
    return axios.post(`/inventory/purchases/${id}/mark_as_sent`);
  },

  // Mark purchase as confirmed
  markAsConfirmed: async (id) => {
    return axios.post(`/inventory/purchases/${id}/mark_as_confirmed`);
  },

  // Add item to purchase
  addItemToPurchase: async (purchaseId, data) => {
    return axios.post(`/inventory/purchases/${purchaseId}/items`, {
      purchase_item: data,
    });
  },

  addItemsBulk: async (purchaseId, requestKey, items, version) => {
    return axios.post(`/inventory/purchases/${purchaseId}/items/bulk`, {
      request_key: requestKey,
      items,
      version,
    });
  },

  searchSupplierProducts: async (supplierId, params = {}) => {
    return axios.get("/inventory/supplier_products/search", { params: { ...params, supplier_id: supplierId } });
  },

  // Update item in purchase
  updateItemInPurchase: async (purchaseId, itemId, data) => {
    return axios.put(`/inventory/purchases/${purchaseId}/items/${itemId}`, {
      purchase_item: data,
    });
  },

  // Remove item from purchase
  removeItemFromPurchase: async (purchaseId, itemId, version) => {
    return axios.delete(`/inventory/purchases/${purchaseId}/items/${itemId}`, { data: { version } });
  },
};

